import { ConfigState } from "@src/types/state"
import { RootState } from "../store"
import { createSelector } from "@reduxjs/toolkit"

// Base selector
export const selectConfig = (state: RootState): ConfigState | null =>
  state.config

// Cart
export const selectTotalCartItems = (state: RootState): number =>
  state.config?.total_cart_items ?? 0

// Keywords
export const selectTrendingKeywords = createSelector(
  state => state.config,
  config => config?.trending_keywords ?? []
)

// Flash sale
export const selectFlashSale = (state: RootState) => state.config?.flash_sale
export const selectIsOnSale = (state: RootState): boolean =>
  state.config?.on_sale ?? false

// Collections and Categories
export const selectCollections = (state: RootState) =>
  state.config?.collections ?? []

export const selectCategories = (state: RootState) =>
  state.config?.categories ?? []

export const selectMenuConfigList = createSelector(
  state => state.config,
  config => config?.menuConfigList ?? []
)
export const selectCurrencyRates = createSelector(state => state.config?.currencyRates, currencyRates => currencyRates ?? [])

export const selectUseSpxAddressSchema = (state: RootState): boolean =>
  Boolean(state.config?.use_spx_address_schema)

export const selectSpxAddressVersion = (state: RootState): 0 | 2 =>
  state.config?.spx_address_version === 2 ? 2 : 0

export const selectIsSpxTwoLevelAddress = (state: RootState): boolean =>
  selectSpxAddressVersion(state) === 2